import React, { Fragment, useEffect, useState, useContext } from "react";
import { Typography } from "@mui/material";
import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import _ from "lodash";
import {
  Card,
  CardContent,
  IconButton,
  Grid,
  Stack,
  // Collapse,
} from "@mui/material";
import CustomDialog from '../common/CustomDialog';
import Drawer from "@mui/material/Drawer";
import AuthContext from '../../context/auth/AuthContext';
import { DateTime } from "luxon";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import { CircularProgress } from "@mui/material";


const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

export default function UserRoleSetupHistory(props) {

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [data, setData] = React.useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const authContext = useContext(AuthContext);
  const { toLocalDateTime, userRoles } = authContext;




  const closeAlert = () => {
    setShowAlert(false);
    props.handleClose();
  };
  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        console.log(`Drawer Mouse Key Event...`);
        // if (
        //   event.type === "keydown" &&
        //   ((event as React.KeyboardEvent).key === "Tab" ||
        //     (event as React.KeyboardEvent).key === "Shift")
        // ) {
        //   return;
        // }
        // console.log(`Toogle Drawer: DockAt:${anchor}, Show: ${open}`);
        // setState({ ...state, [anchor]: open });
        // if (!open) props.handleClose();
      };
  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yyyy hh:mm:ss");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const toLocalDate = (date) => {
    if (date) {
      const options = { day: "2-digit", month: "short", year: "numeric" };
      let stringDate = new Date(date).toLocaleDateString("en-US", options);

      const _date = DateTime.fromFormat(stringDate, "MMM dd, yyyy").toFormat(
        "dd-MMM-yyyy "
      );

      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  useEffect(() => {
    if (
      typeof props.dockAt !== "undefined" &&
      typeof props.show !== "undefined"
    ) {
      console.log(
        `Toogle Drawer UEF: DockAt:${props.dockAt}, Show: ${props.show}`
      );
      // toggleDrawer(props.dockAt, props.show);
      if (props.show) setState({ ...state, [props.dockAt]: props.show });
    }

    // if (
    //   getClientFilingMasterWorkflowAttachments &&
    //   props.workflow &&
    //   props.workflow.workflowId
    // ) {
    //   console.log(`Fetching Commnet for :${props.workflow.workflowId}`);
    //   //   fetchFilingMasterAttachments(props.workflow.workflowId);
    // }
    //eslint-disable-next-line
  }, [props.show]);

  useEffect(() => {
    if (props?.show) {
      console.log("History page", props.activityHistory);
    }
  }, [props.show])


  const newBusinessCategory = (oldBC, newBC) => {
    console.log("newBusinessCategory", oldBC, newBC);

    let BC =
      oldBC.length > 0 ? oldBC.map((ele) => ele.businessCategoryName) : [];
    let changedBC = newBC.map((ele) => ele.businessCategoryName);
    // newBC.forEach((ele) => {
    //   if (ele.businessOperation === "add") {
    //     changedBC.push(ele.businessCategoryName);
    //   } else if (ele.businessOperation === "delete") {
    //     BC.push(ele.businessCategoryName);
    //   }
    // });
    // console.log("newBusinessCategory", BC, changedBC);
    return {
      field: "Business Category",
      old: BC.reduce((acc, item) => acc + (acc === "" ? "" : " , ") + item, ""),
      new: changedBC.reduce(
        (acc, item) => acc + (acc === "" ? "" : " , ") + item,
        ""
      ),
    };
  };

  useEffect(() => {
    try {
      if (props.activityHistory) {

        console.log("activity", props.activityHistory);

        const modifiedActivityHistory = props.activityHistory.map(item => {
          // Initialize new properties
          let newUserNameCC = [];
          let newUserNameTo = [];
          let oldUserNameCC = [];
          let oldUserNameTo = [];

          // Check new_EmailUserCategorys and map accordingly
          if (item.new_EmailUserCategorys && item.new_EmailUserCategorys.length > 0) {
            item.new_EmailUserCategorys.forEach(category => {
              if (category.emailCC) {
                newUserNameCC.push(category.userName);
              }
              if (category.emailTo) {
                newUserNameTo.push(category.userName);
              }
            });
          }

          // Check emailUserCategorys and map accordingly
          if (item.emailUserCategorys && item.emailUserCategorys.length > 0) {
            item.emailUserCategorys.forEach(category => {
              if (category.emailCC) {
                oldUserNameCC.push(category.userName);
              }
              if (category.emailTo) {
                oldUserNameTo.push(category.userName);
              }
            });
          }

          // Return new object with additional properties
          return {
            ...item,
            newUserNameCC: newUserNameCC,
            newUserNameTo: newUserNameTo,
            oldUserNameCC: oldUserNameCC,
            oldUserNameTo: oldUserNameTo
          };
        });
        console.log("modifiedActivityHistory", modifiedActivityHistory);

        setData(() => modifiedActivityHistory);
      }
    } finally {
      setIsLoading(false)
    }
    //eslint-disable-next-line
  }, [props.activityHistory]);



  // const awardAgencyList = [
  //   {
  //     "AwardingAgencyId": 1,
  //     "AwardingAgencyName": "NTIA"
  //   },

  //   {
  //     "AwardingAgencyId": 2,
  //     "AwardingAgencyName": "USDA RUS"
  //   },


  //   {
  //     "AwardingAgencyId": 3,
  //     "AwardingAgencyName": "Treasury"
  //   }
  // ];


  // const newBusinessCategory = (oldBC, newBC) => {
  //   let BC =
  //     oldBC.length > 0 ? oldBC.map((ele) => ele.businessCategoryName) : [];
  //   let changedBC = newBC.map((ele) => ele.businessCategoryName);
  //   // newBC.forEach((ele) => {
  //   //   if (ele.businessOperation === "add") {
  //   //     changedBC.push(ele.businessCategoryName);
  //   //   } else if (ele.businessOperation === "delete") {
  //   //     BC.push(ele.businessCategoryName);
  //   //   }
  //   // });
  //   console.log("newBusinessCategory", BC, changedBC);
  //   return {
  //     field: "Business Category",
  //     old: BC.reduce((acc, item) => acc + (acc === "" ? "" : " , ") + item, ""),
  //     new: changedBC.reduce(
  //       (acc, item) => acc + (acc === "" ? "" : " , ") + item,
  //       ""
  //     ),
  //   };
  // };
  const getClientName = (customerId) => {
    console.log("getClientName", customerId, props.customerList);
    let findName = props.customerList.filter((ele) => ele.code === customerId);
    console.log("getClientName", findName);
    return findName.length > 0 ? findName[0].name : "";
  };

  const getUserName = (userId) => {

    const user = userRoles
      ? userRoles?.filter((user) => user.userId === parseInt(userId))[0]
        ?.userName
      : "";
    return user;
  };
  const getRoleName = (userId) => {

    const user = props.roleList
      ? props.roleList?.filter((user) => user.code === parseInt(userId))[0]
        ?.name
      : "";
    return user;
  };
  const isIncludeNotification = (notification) => {
    return notification ? "Yes" : "No";
  };

  const ListElement = (item, index) => {
    //const [showChanges, setShowChanges] = useState(false);
    console.log("ListElement", item, index);
    return (
      <div className="tn-history-entry" key={index}>
        <Stack direction="row" justifyContent="space-between">
          <ListItem
            disablePadding
            style={{ fontWeight: "bold", fontSize: "16px" }}
          >
            {item.updateUser !== null
              ? getUserName(item.updateUser)
              : getUserName(item.createUser)}
          </ListItem>
          <ListItem sx={{ textAlign: "right" }}>
            <ListItemText
              secondary={
                item && item.updateUser !== null
                  ? toLocalDateTime && `${toLocalDateTime(item.updateDate)}`
                  : toLocalDateTime && `${toLocalDateTime(item.createDate)}`
              }
            />
          </ListItem>
        </Stack>
        <ListItem disablePadding>
          <ListItemText
            primary={
              item && item.process && item.process !== null ? item.process : ""
            }
          />
        </ListItem>

        <TableContainer>
          <Table
            sx={{ minWidth: 250, border: "1px solid black" }}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Field</TableCell>
                <TableCell>Old value</TableCell>
                <TableCell>New value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              {
                item.process === "Newly added" || (item.process === "Modified" && (item.userName !== item.new_UserName)) ?

                  <TableRow>
                    <TableCell>User Name</TableCell>
                    <TableCell>{item.userName}</TableCell>
                    <TableCell>{item.new_UserName}</TableCell>
                  </TableRow> : null
              }
              {
                item.process === "Newly added" || (item.process === "Modified" && (item.loginId !== item.new_LoginId)) ? <TableRow>
                  <TableCell>Login Email</TableCell>
                  <TableCell>{item.loginId}</TableCell>
                  <TableCell>{item.new_LoginId}</TableCell>
                </TableRow> : null}
              {
                item.process === "Newly added" || (item.process === "Modified" && (item.userCustomerId !== item.new_UserCustomerId)) ? <TableRow>
                  <TableCell>Client</TableCell>
                  <TableCell>{getClientName(item.userCustomerId)}</TableCell>
                  <TableCell>{getClientName(item.new_UserCustomerId)}</TableCell>
                </TableRow> : null}
              {
                item.process === "Newly added" || (item.process === "Modified" && (item.roleID !== item.new_RoleID)) ? <TableRow>
                  <TableCell>Role</TableCell>
                  <TableCell>{getRoleName(item.roleID)}</TableCell>
                  <TableCell>{getRoleName(item.new_RoleID)}</TableCell>
                </TableRow> : null}
              {
                item.process === "Newly added" || (item.process === "Modified" && (item.notificationMail !== item.new_NotificationMail)) ? <TableRow>
                  <TableCell>Include Notification </TableCell>
                  <TableCell>{isIncludeNotification(item.notificationMail)}</TableCell>
                  <TableCell>{isIncludeNotification(item.new_NotificationMail)}</TableCell>
                </TableRow> : null}

            </TableBody>
          </Table>
        </TableContainer>
        {/* {item.attachment.length > 0 && (
          <Stack
            direction="row"
            justifyContent="space-between"
            style={{ margin: "10px 0" }}
          >
            <ListItem disablePadding style={{ fontSize: "16px" }}>
              Attachments:
            </ListItem>
            <ListItem sx={{ textAlign: "right" }}>
              {item.attachment.map((ele) => (
                <ListItemText secondary={ele.attachmentName} />
              ))}
            </ListItem>
          </Stack>
        )} */}

        <Divider sx={{ borderBottomWidth: 3 }} />
      </div>
    );
  };

  const list = (anchor) => (
    <Fragment>
      <CustomDialog
        header="Info"
        visible={showAlert}
        onHide={closeAlert}
        footer={null}
      >
        {alertMessage}
      </CustomDialog>
      <Grid container>
        <Stack
          sx={{
            width: anchor === "top" || anchor === "bottom" ? "auto" : "20vw",
            minWidth: "35vw",
            display: "flex",
            alignContent: "center",
          }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <Card sx={{ border: "none", boxShadow: "none" }}>
            <CardContent sx={{ mx: "10px", my: "10px" }}>
              <Stack direction="column" spacing={2}>
                <div
                  style={{
                    width: "30vw",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "1rem",
                  }}
                >
                  ACTIVITY HISTORY
                  <IconButton>
                    <GoogleMaterialIcon name="close" onClick={() => handleCancel(anchor)} />
                  </IconButton>
                </div>
              </Stack>
              {/* <CardContent>
                                {showError && <Alert severity="error">{alertMessage}</Alert>}
                                {showSuccess && (
                                    <Alert severity="success">{alertMessage}</Alert>
                                )}
                            </CardContent> */}
              <Divider sx={{ borderBottomWidth: 3 }} />
              <List>
                {isLoading ?
                  (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100px",
                      }}
                    >
                      <CircularProgress size={40} />
                    </div>
                  ) : (
                    data &&
                    data
                      .slice()
                      .reverse()
                      .map((item, index) => ListElement(item, index))
                  )
                }

                {/* <List>
                  {data &&
                    data
                      .slice()
                      .reverse()
                      .map((item, index) => ListElement(item, index))} */}
              </List>
            </CardContent>
          </Card>
        </Stack>
      </Grid>
    </Fragment>
  );
  const handleCancel = async (anchor) => {
    // setSelectedFile(() => null);
    setShowSuccess(false);
    setShowError(false);
    setData(() => []);
    setIsLoading(true)
    setState({ ...state, [anchor]: false });
    props.handleClose();
  };

  return (
    <div>
      <CustomDialog
        header="Info"
        visible={showAlert}
        onHide={closeAlert}
        footer={null}
      >
        {alertMessage}
      </CustomDialog>
      {typeof props.dockAt !== "undefined" && (
        <React.Fragment>
          <Drawer
            anchor={props.dockAt}
            open={state[props.dockAt]}
            onClose={toggleDrawer(props.dockAt, false)}
          >
            {list(props.dockAt)}
          </Drawer>
        </React.Fragment>
      )}
    </div>
  );
}


